import { InjectionToken } from "@angular/core";

export interface EnvironmentConfig {
	environment: {
		API: string;
		API_OAUTH: string;
		SEGMENT_API_KEY: string;
		URL_BASEERP: string;
		PROXY_BASEERP: string;
		CHAT_INTERCOM_APP_ID: string;
		API_BFF: string;
		ASAAS_CONFIG_URL: string;
		ASAAS_LOGIN_URL: string;
		ASAAS_FORGOT_PASSWORD_URL: string;
		HOTJAR_SITE_ID: number;
		HOTJAR_VERSION: number;
	};
}

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>(
	"EnvironmentConfig"
);
